import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPoints } from '../../../api/me';
import LeaderboardCard from './LeaderboardCard';
import CurrentScoreCard from './CurrentScoreCard';
import PrizeReminderCard from './PrizeReminderCard';

/**
 * Three-card horizontal stack rendered on `/learn` between "Continue
 * learning" and the certificates note. Hidden entirely when the tenant is on a
 * starter plan (gamification soft-disabled). On "leaderboard only" plans
 * (Growth) the prize reminder card is dropped and only two cards render.
 */
export default function GamificationStack() {
  const { data: points, isLoading } = useQuery({
    queryKey: ['me', 'gamification', 'points'],
    queryFn: getPoints,
  });

  // Hide while we don't yet know — avoids a flash of cards on disabled tenants.
  if (isLoading) return null;
  if (points?.enabled === false) return null;

  // Growth is "leaderboard only": no prize shop, so no prize reminder —
  // learners never see a feature their plan doesn't include (rule 2026-07-24).
  const prizesEnabled =
    (points as { prizes_enabled?: boolean } | undefined)?.prizes_enabled !== false;

  return (
    <section className="flex flex-col lg:flex-row items-stretch justify-between gap-6 lg:gap-8 py-2">
      <LeaderboardCard />
      <CurrentScoreCard />
      {prizesEnabled && <PrizeReminderCard />}
    </section>
  );
}
